module.exports = __webpack_public_path__ + "css/fonts.woff2.css";